import { useLocation } from "react-router-dom";
import { PageHero } from "../components/site/PageHero";
import { COMPANY, LEGAL_PAGES } from "../lib/legal";
import { useSeo } from "../lib/seo";

export default function Legal() {
  const slug = useLocation().pathname.replace(/^\//, "");
  const page = LEGAL_PAGES[slug];
  useSeo({ title: `${page.title} | Santiagueño`, description: page.intro, path: `/${slug}` });
  return (
    <>
      <PageHero testid="legal-hero" eyebrow="Legal" lines={[page.title]} intro={page.intro} />
      <section className="bg-[var(--paper)] pb-24">
        <div data-testid={`legal-page-${slug}`} className="mx-auto max-w-3xl space-y-4 px-5 md:px-10">
          {page.sections.map(([h, t], i) => (
            <article key={h} data-testid={`legal-section-${i}`} className="rounded-3xl bg-white p-6 md:p-8">
              <h2 className="font-display text-base md:text-lg">{h}</h2>
              <p className="mt-2 text-sm leading-relaxed text-[var(--muted-ink)] md:text-base">{t}</p>
            </article>
          ))}
          <p className="text-xs text-[var(--muted-ink)]">{COMPANY.name} · CUIT {COMPANY.cuit} · {COMPANY.address}</p>
        </div>
      </section>
    </>
  );
}
